(function(){
    // crack claws widget enable
    //if(Shopify.WR.Settings.template.indexOf('cart') > -1){
        import(Shopify.WR.Settings.modules.WRCart)
            .then(impObj => {
                let WRCartConfig = {
                    cartSubTotalSelector:"[data-cart-subtotal]"
                };
                let WRCart = new impObj.WRCart(WRCartConfig);
                WRCart.init();
                window.ZapietEvent.listen('selected_method', function(checkout_method) { 
                  if(checkout_method === "shipping"){
                      WRCart.removeCrackClaws();
                  }
                  console.log({checkout_method});
                  WRCart.bindCrackClawsEventOnCheckoutEnable();
                });
            
            })
            .catch(err => console.log(err))
    //}
})();